<!--
 * @Descripttion: 个人中心-我的绩效
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-11 11:09:02
-->
<template>
    <div :class="{ 'user-guide-effect-box': steps.step7 }">
        <div class="study-title">
            <div>
                <span>我的绩效</span>
            </div>
        </div>
        <div class="study-center" @click="openHrPortal">
            <div class="study-center-left">
                <div class="offer-center-right-item-title">
                    <span>绩效管理</span>
                </div>
                <div class="offer-center-right-item-text">
                    <span>目标制定、绩效自评、结果查看</span>
                </div>

                <div class="study-center-left-buttom">
                    <el-button type="primary" round style="width:82px" size="mini">
                        查看
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "UserCenterStudy",
    data() {
        return {};
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    methods: {
        openHrPortal() {
            if (this.$config.perfUrl) {
                setTimeout(() => {
                    window.open(this.$config.perfUrl);
                }, 0);
            } else {
                this.$confirm("确定撤回此次预约?", "提示", {
                    message: "该功能暂未上线，敬请期待~~",
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    showCancelButton: false,
                    type: "warning",
                }).then((res) => {
                    console.log(res);
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.user-guide-effect-box {
    position: relative;
    z-index: 999;
    background-color: #fff;
    border-radius: 8px;
    border: 2px solid #3a9d80;
    pointer-events: none;
}
.study-title {
    height: 50px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;

    div {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        padding-top: 20px;
        padding-left: 20px;
    }
}
.study-center {
    border-bottom: 1px solid #e1e2e3;
    display: flex;
    padding-bottom: 20px;
    margin: 0px 20px 0px 20px;
    cursor: pointer;

    .study-center-left {
        width: 368px;
        height: 146px;
        background: #e6fbfb;
        border-radius: 4px;
        padding: 18px 20px 12px 17px;
        background-image: url("../../../../assets/pics/user-center/bsdt.png");
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;
        // position: relative;
        .study-center-left-buttom {
            // position: absolute;
            // bottom: 20px;
        }
        .offer-center-right-item-title {
            width: 80px;

            font-size: 20px;

            font-weight: 500;
            color: #333333;
            padding-bottom: 15px;
        }
        .offer-center-right-item-text {
            width: 312px;
            font-size: 14px;
            font-weight: 400;
            padding-bottom: 32px;
        }
    }
}
</style>
